<script setup lang="ts">
import AiBadgePill from './AiBadgePill.vue';

interface Props {
  reply: string;
}
defineProps<Props>();
</script>

<template>
  <!-- Teal gradient card per spec §2.2.6 (AI content = teal pattern) -->
  <div
    class="bg-gradient-to-br from-teal-50 to-teal-100 border border-teal-200 rounded-lg p-4"
    data-testid="generated-reply-card"
  >
    <!-- AICard teal eyebrow -->
    <div class="flex items-center gap-2 mb-3">
      <AiBadgePill label="AI GENERATED REPLY" />
    </div>

    <p class="text-body text-fg whitespace-pre-wrap">{{ reply }}</p>

    <div class="flex gap-2 mt-4 pt-3 border-t border-teal-200">
      <button
        disabled
        title="Requires Sources slice to ship"
        class="inline-flex items-center gap-1.5 px-3 h-8 text-caption font-medium rounded-md bg-teal-100 text-teal-500 border border-teal-200 opacity-50 pointer-events-none"
      >
        Post to Facebook
      </button>
      <button
        disabled
        title="Requires Public Portal slice to ship"
        class="inline-flex items-center gap-1.5 px-3 h-8 text-caption font-medium rounded-md bg-teal-100 text-teal-500 border border-teal-200 opacity-50 pointer-events-none"
      >
        Reply to submitter
      </button>
      <button
        disabled
        title="Requires AOAI slice to ship"
        class="inline-flex items-center gap-1.5 px-3 h-8 text-caption font-medium rounded-md border border-teal-200 text-teal-500 opacity-50 pointer-events-none"
      >
        Regenerate
      </button>
    </div>
  </div>
</template>
